<template>
  <div class="material">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>My Cloud Booth</BreadcrumbItem>
          <BreadcrumbItem>Material liberary</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">{{exhibition.nameEn}}</div>
        <!-- <p class="header-tool-text">共&nbsp;{{ materialNum }}&nbsp;个素材</p> -->
      </div>
      <div v-show="flag" class="header-tool-box">
        <div class="htb-item" @click="add('photoMaterial')">
          <span class="htb-add">+</span>
          <span>Upload pictures</span>
        </div>
      </div>
      <div v-show="!flag" class="header-tool-box">
        <div class="htb-item" @click="add('videoMaterial')">
          <span class="htb-add">+</span>
          <span>Upload videos</span>
        </div>
      </div>
    </div>
    <p class="header-tool-tip" style="padding-bottom:0;" v-show="flag">(Requirements：.jpg/.png within 2M)</p>
    <p class="header-tool-tip" style="padding-bottom:0;" v-show="!flag">(Requirements: .mp4 within 50M, suggested length is 9-30s, image scale is 16:9)</p>

    <div class="header-tabs">
      <Tabs :animated="false" @on-click="switchBrand" v-model="showTabs">
        <TabPane label="Pictures" name="1"></TabPane>
        <TabPane label="Videos" name="2"></TabPane>
      </Tabs>
      <router-view v-if="String(showTabs) === '1'" ref="photoMaterial"></router-view>
      <router-view v-if="String(showTabs) === '2'" @addVideo="add('videoMaterial')" ref="videoMaterial"></router-view>
    </div>
    <Contact />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Contact from "@components/En/Contact/Contact";
import photoMaterial from "./subpages/photo-material";
import videoMaterial from "./subpages/video-material";
export default {
  name: "exhibition-material",
  data() {
    return {
      showTabs: "1",
      flag: true,
      addPhoto: false,
      materialNum: 0,
      switchName: "1"
    };
  },
  components: {
    Contact,
    photoMaterial,
    videoMaterial
  },
  computed: {
    ...mapGetters({
      getMaterial: "materialModule/getMaterial",
      getVideoMaterial: "materialModule/getVideoMaterial",
      exhibition: "loginModule/getExhibition"
    }),
    path() {
      return this.$route.path;
    }
  },
  created() {
    document.title = "中国国际医疗器械博览会 - Material liberary";
    this.changeTab();
  },
  methods: {
    switchMaterial(name) {
      if (name === "1") {
        this.switchName = "1";
        this.init();
      } else if (name === "2") {
        this.switchName = "2";
        this.init();
      }
    },
    changeTab() {
      if (this.path && this.path.indexOf("video") !== -1) {
        this.showTabs = "2";
        this.flag = false;
      }
    },
    switchBrand(name) {
      if (name === "1") {
        this.$router.push("/exhibitionEn/index/material/photo");
        this.flag = true;
      } else if (name === "2") {
        this.$router.push("/exhibitionEn/index/material/video");
        this.flag = false;
      }
    },  
    add(name) {
      if (this.$refs[name]) {
        this.$refs[name].sendAdd(); 
      }
    }
  }
};
</script> 
<style lang="scss" scoped>
.header-tool {
  display: flex;
  justify-content: space-between;
  padding-right: 25px;
}
</style>